import { render, staticRenderFns } from "./justificatifs.vue?vue&type=template&id=5b4e66de"
import script from "./justificatifs.vue?vue&type=script&lang=js"
export * from "./justificatifs.vue?vue&type=script&lang=js"
import style0 from "./justificatifs.vue?vue&type=style&index=0&id=5b4e66de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports